module.exports = __webpack_public_path__ + "static/img/dice.b996d81.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/dice.gif
// module id = Gpb/
// module chunks = 2